import { gql } from "@apollo/client";

const GET_DOCUMENT_SUB_TYPES = gql`
  query GetDocumentSubTypes {
    deductionDocumentSubtypes {
      count
      items {
        purchaserId
        purchaserKey
        documentTypeId
        documentType
        documentTypeKey
        subtypes {
          documentSubtypeId
          documentSubtype
          documentSubtypeKey
        }
      }
    }
  }
`;

export default GET_DOCUMENT_SUB_TYPES;
